import { render } from "./CRUDTable.vue?vue&type=template&id=0607c4e7"
import script from "./CRUDTable.vue?vue&type=script&lang=js"
export * from "./CRUDTable.vue?vue&type=script&lang=js"
script.render = render

export default script